import util from '@bmp-vue/core/api/util'

const controller = 'ItemsCustomizados'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetAllByReferenciaAndPortal: function (dto) {
    return util.Axios.Post(controller + '/GetAllByReferenciaAndPortal', dto)
  },
  GetUniqueItem: function (dto) {
    return util.Axios.Post(controller + '/GetUniqueItem', dto)
  },
  AddItemCustomizado: function (dto) {
    return util.Axios.Post(controller + '/AddItemCustomizado', dto)
  },
  UpdateStatusItemCustomizado: function (dto) {
    return util.Axios.Post(controller + '/UpdateStatusItemCustomizado', dto)
  },
  RemoveItem: function (dto) {
    return util.Axios.Delete(controller + '/RemoveItem', dto)
  },
  DeleteAllItems: function (dto) {
    return util.Axios.DeleteAll(controller + '/DeleteAllByPortal', dto)
  },
  GetColunasObrigatorias (referenciadores, referenciador) {
    if (referenciadores[0].colunas) {
      const ref = referenciadores.find((r) => (r.text === referenciador))
      const colunasObrigatorias = Object.values(JSON.parse(ref.colunas)).filter((item) => (item.required))
      const headers = colunasObrigatorias.map((item) => (item.nome))
      return headers || []
    }
  },
  GetAllColunas (referenciadores, referenciador) {
    if (referenciadores[0].colunas) {
      const ref = referenciadores.find((r) => (r.text === referenciador))
      const colunasObrigatorias = Object.values(JSON.parse(ref.colunas))
      const headers = colunasObrigatorias.map((item) => (item.nome))
      return headers || []
    }
  }
})
